export default __webpack_public_path__ + "static/media/user-avatar.aa1bdcfd.jpg";